<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column"></h3>
          <div class="card-toolbar">
            <b-button
              variant="primary"
              class="float-right"
              style="padding-top: 6px; padding-bottom: 6px"
              v-on:click.prevent="$router.push('/receipt-type/form')"
            >
              {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
            </b-button>
          </div>
        </div>
        <div class="card-body pt-0 pb-3">
          <div class="col-lg-6 p-0">
            <b-form-group>
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
                  type="search"
                  id="filterInput"
                  debounce="300"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">{{
                    $t("PAGE.DEFAULT.TABLE.CLEAR")
                  }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="tab-content">
            <div class="table-responsive">
              <b-table
                id="receipt-type-table"
                :striped="false"
                :items="filteredItems"
                :fields="fields"
                :busy.sync="isBusy"
                :loading="false"
                :borderless="true"
                head-variant="light"
              >
                <template #cell(id)="data">
                  <div class="text-right">
                    {{ data.index + 1 }}
                  </div>
                </template>

                <template #cell(action)="data">
                  <a
                    href="javascript:"
                    @click.prevent="
                      $router.push(`/receipt-type/form/${data.item.id}`)
                    "
                    class="btn btn-icon btn-light btn-sm"
                    :aria-label="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-success">
                      <inline-svg
                        src="media/svg/icons/General/Edit.svg"
                      ></inline-svg>
                    </span> </a
                  >&nbsp;&nbsp;&nbsp;
                  <a
                    href="javascript:"
                    @click.prevent="removeData(data.item.id)"
                    class="btn btn-icon btn-light btn-sm"
                    :aria-label="
                      $t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE')
                    "
                  >
                    <span class="svg-icon svg-icon-md svg-icon-danger">
                      <inline-svg
                        src="media/svg/icons/General/Trash.svg"
                      ></inline-svg>
                    </span>
                  </a>
                </template>
              </b-table>
              <p class="text-center pt-3" v-if="filteredItems.length < 1">
                {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.actionField {
  min-width: 100px;
  width: 100px;
  max-width: 100px;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import {
  GET_RECEIPT_TYPE,
  DELETE_RECEIPT_TYPE
} from "@/core/services/store/receipt_type.module";

export default {
  data() {
    return {
      fields: [
        {
          key: "id",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          sortable: false
        },
        {
          key: "name",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.NAME")}`,
          sortable: false
        },
        {
          key: "limit_validator",
          label: `${this.$t("PAGE.RECEIPT_TYPE.TABLE.FIELDS.LIMIT_VALIDATOR")}`,
          sortable: false
        },
        {
          key: "sort_number",
          label: `${this.$t("PAGE.RECEIPT_TYPE.TABLE.FIELDS.SORT_NUMBER")}`,
          sortable: false
        },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          tdClass: "actionField"
        }
      ],
      isBusy: false,
      items: [],
      filter: ""
    };
  },
  computed: {
    filteredItems() {
      if (!this.filter) {
        return this.items;
      }

      const keyword = this.filter.toString().trim().toLowerCase();
      return this.items.filter((item) => {
        return (
          (item.name || "").toString().toLowerCase().includes(keyword) ||
          (item.limit_validator || "")
            .toString()
            .toLowerCase()
            .includes(keyword)
        );
      });
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.RECEIPT_TYPE_MANAGEMENT.TITLE")}` }
    ]);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isBusy = true;
      this.$store
        .dispatch(GET_RECEIPT_TYPE, { params: { master_only: 1 } })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    removeData(id) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_RECEIPT_TYPE, { id })
            .then(({ data }) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.fetchData();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
              this.isBusy = false;
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              this.isBusy = false;
            });
        }
      });
    }
  }
};
</script>
